import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import {
  MsalService,
  MsalModule,
} from '@azure/msal-angular';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { LoginService } from '../services/login.service';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    imports: [
        CommonModule,
        MsalModule,
        MatToolbarModule,
        MatButtonModule,
        MatMenuModule,
    ]
})
export class LandingComponent implements OnInit, OnDestroy {
  header = environment.header;
  highlightHeader = environment.highlightHeader;
  primaryHeader = environment.primaryHeader;
  description = environment.description;

  title = 'Angular Standalone Sample - MSAL Angular';
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private loginService: LoginService,
    private router: Router
  ) {}

  ngOnInit(): void {    
   // this.authService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
  }

  login() {
    this.loginService.loginRedirect().subscribe({
      next: () => {
        this.router.navigate(['/']);
      },
      error: (error) => console.log(error)
    });
  }

  ngOnDestroy(): void {
  }
}
